import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useClerk } from "@clerk/react";
import { Pencil, LogOut, ExternalLink } from "lucide-react";
import { useProfile } from "@/context/ProfileContext";
import { ProfileHeader } from "@/components/profile/ProfileHeader";
import { ProfileStats } from "@/components/profile/ProfileStats";
import { AvatarUploader } from "@/components/profile/AvatarUploader";
import { EditProfileDialog } from "@/components/profile/EditProfileDialog";
import { MyTracks } from "@/components/profile/MyTracks";
import { ProfileVideos } from "@/components/video/ProfileVideos";
import { MembershipCard } from "@/components/membership/MembershipCard";
import { PROFILE } from "@/constants/testIds";

export default function Profile() {
  const { profile } = useProfile();
  const { signOut } = useClerk();
  const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const isCreator = profile.account_type === "creator";

  return (
    <div data-testid={PROFILE.page} className="space-y-6 animate-rise">
      <ProfileHeader profile={profile} avatar={<AvatarUploader />} actions={
        <button data-testid={PROFILE.editButton} onClick={() => setEditing(true)} className="btn-chrome px-4 py-2.5 text-sm inline-flex items-center gap-2">
          <Pencil className="h-4 w-4" /> Edit profile
        </button>
      } />
      <ProfileStats stats={profile.stats} isCreator={isCreator} />
      <div className="grid gap-4 sm:grid-cols-2">
        <MembershipCard />
        <div className="rounded-2xl border border-white/10 bg-nw-surface/60 p-5 space-y-3">
          <p className="text-xs uppercase tracking-widest text-slate-500">Public page</p>
          <Link data-testid={PROFILE.shareLink} to={`/u/${profile.username}`} className="inline-flex items-center gap-2 font-mono text-sm text-slate-200 hover:text-nw-red transition-colors">
            /u/{profile.username} <ExternalLink className="h-4 w-4" />
          </Link>
          <button data-testid={PROFILE.signOut} onClick={() => { navigate("/"); signOut({ redirectUrl: "/" }); }} className="flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors">
            <LogOut className="h-4 w-4" /> Sign out
          </button>
        </div>
      </div>
      {isCreator && <MyTracks />}
      {isCreator && <ProfileVideos username={profile.username} manage />}
      <EditProfileDialog open={editing} onOpenChange={setEditing} />
    </div>
  );
}
